import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { http, errMsg, TOKEN_KEY } from "@/lib/api";

export const PinDialog = ({ open, onOpenChange }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (value) => {
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/admin/login", { pin: value });
      localStorage.setItem(TOKEN_KEY, data.token);
      navigate("/admin");
    } catch (e) {
      setError(errMsg(e));
      setPin("");
    } finally {
      setLoading(false);
    }
  };

  const onChange = (v) => {
    setPin(v);
    if (v.length === 4) submit(v);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1C1515] border-[#2E2323] text-amber-50 max-w-xs" data-testid="pin-dialog">
        <DialogHeader className="items-center text-center">
          <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center mb-2"><Lock className="w-5 h-5 text-amber-400" /></div>
          <DialogTitle>Acceso administrador</DialogTitle>
          <DialogDescription className="text-[#A89F91]">Ingresá el PIN de 4 dígitos</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center py-2">
          <InputOTP maxLength={4} value={pin} onChange={onChange} disabled={loading} inputMode="numeric" pattern="^[0-9]*$" data-testid="pin-input">
            <InputOTPGroup>
              {[0, 1, 2, 3].map((i) => <InputOTPSlot key={i} index={i} className="w-12 h-14 text-xl border-[#2E2323] bg-[#120E0E]" />)}
            </InputOTPGroup>
          </InputOTP>
        </div>
        {error && <p className="text-center text-sm text-red-400" data-testid="pin-error">{error}</p>}
      </DialogContent>
    </Dialog>
  );
};
